

import * as fromFormsState from './custom-forms.state';
import * as fromFormsActions from './custom-forms.actions';
import * as Objects from '@core/objects';

import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";

export function settingsCustomFormsReducer(state = fromFormsState.initialState, action: fromFormsActions.SettingsFormsActions): fromFormsState.SettingsCustomForms {

    switch(action.type){
        case fromFormsActions.SettingsFormsActionsType.LoadFormsSuccess:
            return {...state, 
                forms: action.forms,
                starting: {...state.starting, initialized_forms: true}
            };
        case fromFormsActions.SettingsFormsActionsType.LoadFormSuccess:
            return {...state,
                editing: {...state.editing, form: action.form}
            };

        case fromFormsActions.SettingsFormsActionsType.LoadFieldsSuccess:
            return {...state,
                editing: {...state.editing, fields: action.fields, starting_fields: action.fields },
                starting: {...state.starting, initialized_fields: true }
            };
        // sync 
        case fromFormsActions.SettingsFormsActionsType.SetFormName:
            return {...state,
                editing: {...state.editing, 
                    form : {...state.editing.form, name: action.name, changed: true},
                    modified: true
                }
            };
        case fromFormsActions.SettingsFormsActionsType.SetFormDescription:
            return {...state,
                editing: {...state.editing, 
                    form : {...state.editing.form, description: action.description},
                    modified: true
                }
            };
        case fromFormsActions.SettingsFormsActionsType.AddField:
            //  add new Feld instance
            return {
                ...state,   
                editing: {
                    ...state.editing,
                    fields: [...state.editing.fields, action.newField],
                    modified: true
                },
            };
        case fromFormsActions.SettingsFormsActionsType.SetField:
            // update new field propteties after being add
            return {...state,
                editing: {...state.editing, 
                    fields : state.editing.fields.map((fi) =>
                            fi.id === action.updatedField.id ? action.updatedField : fi 
                        ),  
                    modified: true
                }
            };
        case fromFormsActions.SettingsFormsActionsType.MoveFieldUp:
            // If the field is at the first position, no move
            if (action.field.position === 0) {
                return state; 
            }

             // Create a new array of fields with updated positions
            const updatedUFields = state.editing.fields.map((field) => {
                if (field.position === action.field.position) {
                    // Move the selected field up by updating its position
                    return field.update({ position: action.field.position - 1 });
                } else if (field.position === action.field.position - 1) {
                    // Move the field just above the selected one down
                    return field.update({ position: action.field.position });
                }
                return field; // Keep other fields unchanged
            });

            return {
                ...state,
                editing: {
                    ...state.editing,

                    fields: updatedUFields,
                    modified: true
                },
            };
        case fromFormsActions.SettingsFormsActionsType.MoveFieldDown:
            // find the highest active position
            const highestActivePosition = Math.max(...state.editing.fields.filter(f => f.active).map(af => af.position));
            // If the field is at the last position, no move
            if (action.field.position === highestActivePosition) {
                return state; 
            }

            // Create a new array of fields with updated positions
            const updatedDFields = state.editing.fields.map((field) => {
                if (field.position === action.field.position) {
                    // Move the selected field down by updating its position
                    return field.update({ position: action.field.position + 1 });
                } else if (field.position === action.field.position + 1) {
                    // Move the field just below the selected one up
                    return field.update({ position: action.field.position });
                }
                return field; // Keep other fields unchanged
            });

            return {
                ...state,
                editing: {
                    ...state.editing,
                    fields: updatedDFields,
                    modified: true
                },
            };
        case fromFormsActions.SettingsFormsActionsType.UpdateFieldPositions:
            // get updated list with the given new positions
            const updatedPFields = state.editing.fields.map((field) => {
                const updatedField = action.fields.find(f => f.id === field.id);
                return updatedField ? updatedField : field;
            });
            // Sort the updatedPFields array by the position property to set fields in array in position order
            const sortedFields = updatedPFields.sort((a, b) => a.position - b.position);

            return {
                ...state,
                editing: {
                    ...state.editing,
                    fields: sortedFields,
                    modified: true,
                },
            };
        

        case fromFormsActions.SettingsFormsActionsType.RemoveField:
            // Step 1: Check if the field exists in the starting_fields list
            const fieldExistsInStartingFields = state.editing.starting_fields.some(sf => sf.id === action.field.id);
            // Step 2-a:If the field exists in starting_fields, 
            //      mark the field not active and position -1 and move following positions 1 position down
            // Step 2-b:If not, remove directly
            return {
                ...state,
                editing: {
                    ...state.editing,
                    fields: fieldExistsInStartingFields 
                            ? state.editing.fields.map((fi: SettingsCustomFormFieldData) => 
                                    fi.id === action.field.id ? fi.update({active: false, position: -1 }) : fi
                                ).map((fu: SettingsCustomFormFieldData) => 
                                    fu.position > action.field.position && fu.active ? fu.update({ position: fu.position-1 }) : fu
                                ) 
                            : state.editing.fields
                                .filter((fi: SettingsCustomFormFieldData) => fi.id !== action.field.id)
                                .map((fu: SettingsCustomFormFieldData) =>
                                    fu.position > action.field.position && fu.active ? fu.update({ position: fu.position - 1 }) : fu
                                ),
                    modified: true
                }
            }

        // saves && updates
        case fromFormsActions.SettingsFormsActionsType.SaveForm:
            return {...state, 
                errors: {...state.errors, save_form: null },
            };
        case fromFormsActions.SettingsFormsActionsType.SaveFormSuccess:
            return {...state, 
                forms: state.forms.map(
                    (f: Objects.Form) => f.id == action.form.id ? action.form : f),
                
                editing: {...state.editing, 
                    form: action.form
                },
            };
        case fromFormsActions.SettingsFormsActionsType.SaveFormError:
            // reload or what else
            return {...state, 
                errors: {...state.errors, save_form: action.error }
            };
        
        case fromFormsActions.SettingsFormsActionsType.SetActiveForm :
            return {...state,
                forms: state.forms.map(
                    (f: Objects.Form) => f.id == action.formId ? {...f, active: action.active} : f),
                errors: {...state.errors, set_active_form: null },
            };
        case fromFormsActions.SettingsFormsActionsType.SetActiveFormSuccess :
            return {...state, 
                forms: state.forms.map(
                    (f: Objects.Form) => f.id == action.form.id ? action.form : f)
            };
        case fromFormsActions.SettingsFormsActionsType.SetActiveFormError:
            // reload or what else
            return {...state, 
                errors: {...state.errors, set_active_form: action.error }
            };
        case fromFormsActions.SettingsFormsActionsType.SaveFields:
            return {...state, 
                errors: {...state.errors, save_fields: null }
            };
        case fromFormsActions.SettingsFormsActionsType.SaveFieldsError:
// TODO restore or reload or what else.
            return {...state, 
                errors: {...state.errors, save_fields: action.error }
            };
        case fromFormsActions.SettingsFormsActionsType.SaveFieldsSuccess:
            // set the updated by id in the editing fields list 
            return {...state, 
                editing: {...state.editing, 
                    fields: state.editing.fields.map((field: SettingsCustomFormFieldData) => {
                        const updatedField = action.fields.find((f) => f.id === field.id);
                        return updatedField ?? field;
                    }),
                    modified: false
                },
            };

        case fromFormsActions.SettingsFormsActionsType.ClearEditing:
            return {...state,
                editing: fromFormsState.initialState.editing,
                starting: {...state.starting, initialized_fields: fromFormsState.initialState.starting.initialized_fields},
                errors: fromFormsState.initialState.errors,
            };
        default:
	        return state;

    }
}
